import { Services } from '@sigma-frontend-libs/commons'

import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    hasOwner: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    hasPermissions() {
      return this.checkPermissions(`advanced.${Services.tokens}.get`)
    },

    $_to() {
      if (this.hasPermissions) {
        return {
          name: `${Services.tokens}.single`,
          params: { id: this.value.id }
        }
      }
    }
  },

  render
}
